import React from "react";
import { grid } from "../constants";
import Text from "@/bit/components/next13.components.text";

const Title = ({ title, subTitle, isOpen }) => {
  return (
    <>
      <div className="title-cont" data-cy="Ecosystem Container Text">
        <div className="animation-cont">
          {title && <Text {...title} cyData="Ecosystem Title" />}
          {subTitle && <Text {...subTitle} cyData="Ecosystem SubTitle" />}
        </div>
      </div>
      <style jsx>{`
        .title-cont {
          overflow: hidden;

          .animation-cont {
            opacity: ${isOpen ? 0 : 1};
            transition: opacity 300ms linear;

            :global(.title) {
              text-align: center;
              padding: 1rem 2rem;
            }

            :global(.sub-title) {
              text-align: center;
              padding: 1rem 0;
            }
          }
        }

        // Tablet
        @media screen and (min-width: ${grid.breakpoint_sm}px) {
          .title-cont {
            .animation-cont {
              :global(.title) {
                padding: 0;
                font-size: 2.5rem;
                padding: 0 0;
                text-align: left;
                margin-bottom: 0.5rem;
              }

              :global(.sub-title) {
                padding: 0;
                font-size: 1.25rem;
                text-align: left;
              }
            }
          }
        }
        // Desktop
        @media screen and (min-width: ${grid.breakpoint_md}px) {
        }
      `}</style>
    </>
  );
};

export default Title;
